import { Component, Input, AfterViewInit, OnChanges } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { BaseOperation } from 'src/app/perical/models/thermal-operation.model';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { formatUnitNumber } from 'src/app/shared/helpers/unit-number-format.helper';
import { ExternalPressureProfileType, PericalLinkEPP } from '../../models/external-pressure-profile.model';

interface PericalLinkEPPForm {
  type: ExternalPressureProfileType.PERICALLINK;
  thermalOperation: Partial<BaseOperation>;
}

@Component({
    selector: 'app-perical-link-epp',
    template: `
    <form [formGroup]="form.formGroup" >
      <label for="thermalOperation">Thermal Operation</label>
      <app-units-select-input
        filter
        filterBy="name"
        class="w-full"
        inputId="thermalOperation"
        dataKey="id"
        [readOnly]="isReadOnly"
        [options]="thermalOperations"
        [formControlName]="form.formControlNames.thermalOperation"
        [optionLabelFormatter]="formatOperationOption"
        [unit]="userUnits?.shortLengths ?? 'in'"
        appendTo="body"
      ></app-units-select-input>
    </form>
    `,
    providers: subformComponentProviders(PericalLinkEppComponent),
    standalone: false
})
export class PericalLinkEppComponent implements OnChanges, AfterViewInit {
  @Input() thermalOperations: Partial<BaseOperation>[];
  @Input() isReadOnly: boolean;
  @Input() userUnits: UserUnitsModel;

  public readonly formatOperationOption = (operation: Partial<BaseOperation>): string => {
    const unit = this.userUnits?.shortLengths ?? 'in';
    return (operation.name ?? '').replace(/\d+\.\d+/g, value =>
      formatUnitNumber(Number(value), unit, undefined, undefined, { [unit]: unit === 'in' ? 3 : 2 })
    );
  };

  public form = createForm<PericalLinkEPP, PericalLinkEPPForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(ExternalPressureProfileType.PERICALLINK),
      thermalOperation: new UntypedFormControl(null, Validators.required)
    },
    toFormGroup: (obj: PericalLinkEPP): PericalLinkEPPForm => {
      return {
        type: ExternalPressureProfileType.PERICALLINK,
        thermalOperation: !obj.thermalOperationId ? (!this.thermalOperations ? null : this.thermalOperations[0]) : this.thermalOperations.find(op => op.id === obj.thermalOperationId)
      };
    },
    fromFormGroup: (formValue: PericalLinkEPPForm): PericalLinkEPP => {
      return {
        type: ExternalPressureProfileType.PERICALLINK,
        thermalOperationId: formValue.thermalOperation.id
      };
    }
  });

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.form.formGroup.controls.thermalOperation.value  && this.thermalOperations) {
        this.form.formGroup.controls.thermalOperation.setValue(this.thermalOperations[0]);
      }
    }, 100);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (!this.form.formGroup.controls.thermalOperation.value  && this.thermalOperations) {
        this.form.formGroup.controls.thermalOperation.setValue(this.thermalOperations[0]);
      }
    }, 100);
  }
}
